'use client';

import { useTranslations } from 'next-intl';
import { MyEquipmentWarning } from 'components/pcc-components';
import { CatIconInfo } from '@blocks-react/components/Icons/Info';

export const SelectEquipmentDrawerWarning = () => {
  const t = useTranslations();

  return (
    <div className="mx-n3 mt-n3 mb-3 pb-1">
      <MyEquipmentWarning errorNote={t('NO_EQUIPMENT_SELECTED')}>
        <>
          <CatIconInfo slot="before" />
          <span>{t('SELECT_EQUIPMENT_FROM_LIST_MSG')}</span>
        </>
      </MyEquipmentWarning>
    </div>
  );
};
